import { useMemo } from "react";

import "../api";

import { useModuleConfigurationSchema } from "@/features/integrations/hooks/useModuleConfiguration";
import type { UiComponent } from "@/features/integrations/types";
import { useAuth } from "@/lib/hooks/useAuth";

export function useCampaignsDataProvider(
  integrationName: string | undefined,
  clientId?: string | null
) {
  const { tenantId } = useAuth();
  const normalizedName = integrationName?.toLowerCase() || "";

  const schemaQuery = useModuleConfigurationSchema(
    normalizedName,
    "campaigns",
    clientId
      ? { level: "client" as const, tenantId: tenantId ?? null, clientId }
      : { level: "tenant" as const, tenantId: tenantId ?? null },
    !!normalizedName
  );

  return useMemo(() => {
    const ui: UiComponent[] = schemaQuery.data?.ui ?? [];
    return {
      getIntegrationName: () => normalizedName,
      getTranslationNamespace: () => `integrations.${normalizedName}.campaigns`,
      getClientViews: () => ui,
    };
  }, [normalizedName, schemaQuery.data]);
}
